import { AccountStatus } from '@/swagger/constants/anagraphics-enums';

export const it = {
  department: {
    pageTitle: 'Il mio dipartimento',
    team: {
      pageTitle: 'Il mio team',
    },
    tabs: {
      overview: 'Overview dipartimento',
      overviewTeam: 'Overview team',
      assessment: 'Assessment',
    },
    dataMismatchWarning: 'In caso di incongruenza tra i dati rivolgiti all’amministratore',
    details: {
      description: 'Seleziona un questionario tra quelli sotto elencati per vedere i risultati.',
      manager: 'Responsabile: ',
      departmentManager: 'Responsabile del dipartimento',
      teamManager: 'Responsabile del team',
      noDepartmentName: 'Senza nome',
      noTeamName: 'Membri del dipartimento',
      validProfiles: 'Profili validi',
      profilesToCorrect: 'Profili da correggere',
      team: 'Team',
      teamMembers: 'Membri del team',
      members: 'Membri',
      tabs: {
        profile: 'Profilo',
        assessment: 'Assessment',
      },
      status: {
        [AccountStatus.ENABLED]: 'Attivo',
        [AccountStatus.PENDING]: 'In sospeso',
        [AccountStatus.DISABLED]: 'Disattivo',
        [AccountStatus.NOT_INVITED]: 'Non attivo',
      },
      tableEmployees: {
        title: 'Elenco anagrafiche',
        firstName: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        role: 'Ruolo Aziendale',
        department: 'Dipartimento',
        status: {
          label: 'Stato utenza',
          tooltip:
            "Indica lo stato dell'utente nella piattaforma Slash. Può essere Attivo, Non attivo, In sospeso o Disattivo.",
        },
      },
      assessment: {
        title: '{{name}} assessment',
        description: 'Seleziona un questionario tra quelli sotto elencati per vedere i risultati.',
        status: {
          completed: 'Completato il {{date}}',
          notCompleted: 'Inviato',
          noSurvey: 'Non inviato',
        },
        noResultsVisible: {
          title: 'Risultati del {{templateName}} non sono disponibili',
          description:
            'I risultati dell’assessment non sono attualmente visibili. Per saperne di più o avere maggiori dettagli, contatta l’HR.',
        },
        noData: {
          title: 'Dati sugli assessment non disponibili',
          descriptionEmployee:
            'Non sono disponibili dati sugli assessment per questo dipendente. Per maggiori informazioni contatta l’Admin della piattaforma.',
          descriptionTeam:
            'A nessun membro del tuo team è stato inviato nessun Assessment. Per maggiori informazioni contatta l’Admin della piattaforma.',
          descriptionDepartment:
            'A nessun membro del tuo dipartimento è stato inviato nessun Assessment. Per maggiori informazioni contatta l’Admin della piattaforma.',
        },
        intro: {
          description: {
            single:
              "I dati si riferiscono agli utenti che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utente.",
            plural:
              "I dati si riferiscono agli utenti che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utenti.",
          },
        },
        descriptionNotSent:
          'L’assessment non è stato ancora inviato a questo utente. Per maggiori informazioni contatta l’admin della piattaforma.',
        descriptionCompleted:
          'Il grafico riporta i punteggi medi (scala 0-7) sulle {{metricsCount}} {{surveyTemplateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
        descriptionNotCompleted:
          'L’assessment è stato inviato ma l’utente non l’ha ancora completato.',
        generalDescriptionDepartment:
          'I dati si riferiscono agli utenti del dipartimento {{departmentName}} che hanno completato l’assessmente sulle soft skills. La base di analisi è costituita da {{invitedUser}} utenti.',
        generalDescriptionTeam:
          'I dati si riferiscono agli utenti del team {{teamName}} che hanno completato l’assessmente sulle soft skills. La base di analisi è costituita da {{invitedUser}} utenti.',
        descriptionTitle: 'Descrizione',
        surveyResults: {
          title: 'Punteggio per {{surveyTemplateName}}',
          description:
            'Il grafico riporta i punteggi medi (scala 0-7) sulle 6 soft skill, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
          insightBox: {
            title: 'Insight',
            proTitle: 'Punti di forza',
            conTitle: 'Punti di debolezza',
          },
          alertBadge:
            'Il modello è in fase di validazione scientifica e mostra un livello di affidabilità consistente, soprattutto nella visualizzazione aggregata per team e dipartimenti',
        },
        genericSurveyResults: {
          title: 'Soft skills assessment',
          titleAverage: 'Punteggio medio',
          genericAverageGraphTitle: 'Punteggio medio per {{surveyTemplateName}}',
          description:
            'Il grafico riporta i punteggi medi (scala 0-7) sulle {{metricsCount}} {{surveyTemplateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
          overview: {
            completed: 'Questionari completati',
            invited: 'Questionari inviati',
            toComplete: 'Questionari da completare',
            completionRate: 'Tasso di completamento',
          },
          insightBox: {
            title: 'Insight',
            proTitle: 'Punti di forza',
            conTitle: 'Punti di debolezza',
          },
        },
        resultsVsOrganization: {
          title: 'Andamento rispetto al Team {{teamName}} e al Dipartimento {{departmentName}}',
          description:
            'Confronto tra i punteggi medi del dipendente, del team e del dipartimento di appartenenza.',
          labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{teamValue}} vs media team',
          legend: {
            yourScore: 'Personale',
            teamAverage: 'Team {{teamName}}',
          },
        },
        resultsDepartmentVsOrganization: {
          title: 'Andamento del dipartimento rispetto all’organizzazione',
          description:
            'Confronto tra i punteggi medi del dipartimento e quelli dell’intera organizzazione.',
          labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{diffValue}} vs media organizzazione',
          legend: {
            depAverage: 'Dipartimento ({{total}} persone)',
            orgAverage: 'Organizzazione ({{total}} persone)',
          },
        },
        resultsTeamVsDepartmentVsOrganization: {
          title: 'Andamento del team rispetto al dipartimento e all’organizzazione',
          description:
            'Confronto tra i punteggi medi del team, del dipartimento e dell’organizzazione.',
          labelTooltipChart:
            'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento\n\n{{orgValue}} vs media organizzazione',
          legend: {
            teamAverage: 'Team ({{total}} persone)',
            depAverage: 'Dipartimento ({{total}} persone)',
            orgAverage: 'Organizzazione ({{total}} persone)',
          },
        },
        resultsTeamVsDepartment: {
          title: 'Andamento del team rispetto al dipartimento',
          description: 'Confronto tra i punteggi medi del team e del dipartimento di appartenenza.',
          labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento',
          legend: {
            teamAverage: 'Team ({{total}} persone)',
            depAverage: 'Dipartimento ({{total}} persone)',
          },
        },
        resultsEmployeeVsTeamVsDepartment: {
          title: 'Andamento del dipendente rispetto a team e a dipartimento',
          description:
            'Confronto tra i punteggi medi del dipendente, del team e del dipartimento di appartenenza',
          labelTooltipChart:
            'Punteggio: {{current}} pt\n\n{{teamValue}} vs media team\n\n{{depValue}} vs media dipartimento',
          legend: {
            employee: 'Dipendente',
            teamAverage: 'Team ({{total}} persone)',
            depAverage: 'Dipartimento ({{total}} persone)',
          },
        },
        resultsEmployeeVsTeam: {
          title: 'Andamento del dipendente rispetto al team',
          description: 'Confronto tra i punteggi medi del dipendente e del team di appartenenza.',
          labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento',
          legend: {
            employee: 'Dipendente',
            teamAverage: 'Team ({{total}} persone)',
          },
        },
        distributionBox: {
          title: 'Distribuzione dei punteggi per skill',
          description:
            'La distribuzione mostra la percentuale di utenti del dipartimento collocati nei tre livelli di competenza per ciascuna skill.',
          descriptionTeam:
            'La distribuzione mostra la percentuale di utenti del team collocati nei tre livelli di competenza per ciascuna skill.',
        },
        surveyTitle: {
          notCompleted: 'Punteggio {{surveyTemplateName}}',
          completed: 'Punteggio medio per {{surveyTemplateName}}',
        },
      },
    },
    tutorial: {
      department: {
        title: 'Il tuo dipartimento',
        slides: {
          slide1: {
            title: 'Esplora la panoramica del dipartimento',
            description:
              'Nella scheda Overview dipartimento puoi visualizzare la struttura completa del tuo dipartimento: responsabili, team e stato attività dei singoli membri. Da qui puoi accedere facilmente alle schede dei team o ai profili individuali.',
          },
          slide2: {
            title: 'Consulta i profili dei tuoi collaboratori',
            description:
              'Dall’Overview dipartimento puoi accedere ai profili dei singoli dipendenti. Ogni scheda mostra le informazioni sull’utenza, i punteggi individuali, gli insight e le date di completamento degli assessment.',
          },
          slide3: {
            title: 'Visualizza i risultati degli assessment',
            description:
              'Dalla sezione Assessment puoi monitorare i risultati del tuo dipartimento e dei singoli team. Confronta i risultati tra team e scopri come il tuo dipartimento si posiziona rispetto alla media aziendale.',
          },
          slide4: {
            title: 'Analizza le performance dei team',
            description:
              'Per ciascun team puoi accedere a un dettaglio dedicato che raccoglie i risultati medi dei diversi assessment, evidenziando punti di forza e aree di miglioramento. I grafici radar e la distribuzione dei livelli ti aiutano a interpretare rapidamente le performance del team e a individuare dove intervenire con azioni di sviluppo mirate.',
          },
        },
      },
      team: {
        title: 'Il tuo team',
        slides: {
          slide1: {
            title: 'Esplora la panoramica del tuo team',
            description:
              'Nella scheda Overview team puoi consultare la struttura del gruppo, verificare i ruoli, lo stato utente e i membri attivi. Da qui puoi entrare nei profili individuali e visualizzare i dettagli dei singoli componenti.',
          },
          slide2: {
            title: 'Consulta i profili dei componenti',
            description:
              'Accedi ai profili individuali per consultare i risultati dei vari assessment, con una panoramica chiara dei punti di forza e delle aree di miglioramento di ciascuna persona.',
          },
          slide3: {
            title: 'Visualizza i risultati degli assessment del team',
            description:
              'Dalla sezione Assessment puoi monitorare i risultati del tuo team e confrontarli con la media del dipartimento. Il radar e i grafici a barre mostrano la distribuzione dei livelli di competenza su ciascuna soft skill.',
          },
        },
      },
    },
  },
};
